import { useLanguage } from "@/i18n";
import { Reveal, MaskedLine } from "@/components/Reveal";

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="chi-sono" data-testid="about-section" className="relative scroll-mt-24 bg-azure py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-bl from-[#0B334D] via-transparent to-[#0B334D]/60" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="overflow-hidden rounded-md border-4 border-[#C9A227]/25 shadow-2xl max-w-md mx-auto lg:mx-0">
            <img
              src="/images/guido.webp"
              alt={t.about.photoAlt}
              data-testid="about-image"
              className="w-full aspect-[4/5] object-cover object-top"
            />
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-dune mb-5">{t.about.overline}</p>
          </Reveal>
          <h2 data-testid="about-title" className="font-serif font-light tracking-tight leading-[1.08] text-4xl sm:text-5xl lg:text-6xl text-[#D2A24C] mb-8">
            <MaskedLine delay={0.1}>{t.about.title}</MaskedLine>
          </h2>
          <Reveal delay={0.15}>
            <p className="text-base lg:text-lg leading-relaxed text-[#F3EFE9]/90 max-w-2xl mb-9">{t.about.intro}</p>
          </Reveal>
          <ul className="space-y-6 max-w-2xl">
            {t.about.points.map((p, i) => (
              <Reveal key={p.lead} delay={0.2 + i * 0.08}>
                <li data-testid={`about-point-${i + 1}`} className="text-base leading-relaxed text-[#F3EFE9]/85 border-l-2 border-[#C9A227]/60 pl-5">
                  <strong className="text-[#D2A24C] font-bold">{p.lead}</strong> {p.text}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.45}>
            <p data-testid="about-closing" className="mt-11 font-serif italic text-2xl lg:text-3xl leading-snug text-[#FDFBF7] max-w-xl">
              {t.about.closing}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
